import { AbstractControl } from '@angular/forms';

export function vulgarFractionValidator(control: AbstractControl) {

    const input: string = control && control.value || '';

    if (input.match(/[\u00Bd-\u00BE\u2150-\u215E]/g)) {
        return { stringFormat: false };
    }

}
